(function ($) {
  $(window).scroll(function () {
    let scroll = $(window).scrollTop();
    if (scroll > 400) {
      $('body').addClass('scroll-topbanner');
    } else {
      $('body').removeClass('scroll-topbanner');
    }
  });

  $('.a2a_kit').on('click', 'a', function (e) {
    e.preventDefault();
    window.open($(this).attr('href'), 'share', "width=500, height=500, toolbar=no,menubar=no,location=no");
  });
}) (jQuery);